module.exports = __webpack_public_path__ + "img/171-7d700e.png";